import { useKitPermissions } from '@cheqroom/hooks';
import { FC } from 'react';

import { useItemInfoContext } from '../../ItemInfo.context';
import { PartOfKitContent } from './PartOfKitContent';

export const PartOfKit: FC = () => {
	const { user, workspace, components } = useItemInfoContext();
	const Link = components?.Link ?? 'a';
	const canSeeKits = useKitPermissions({ user: user ?? null, workspace: workspace ?? null }).canRead();

	return <PartOfKitContent renderKitLink={(url) => (canSeeKits ? <Link href={url} /> : <span />)} />;
};
